import http from '@/core/http'
import { cloneDeep, map } from 'lodash'

const state = {
  itens: [],
  item: {
    name: '',
  },
  totalItens: {}
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get('entidades/cliente', { params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },
  getItem: ({ commit }, payload) => {
    commit('LISTA_ITEM', payload)
  },
  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },
  deletarItem: async (_, payload) => {
    const result = await http.delete('entidades/cliente', { params: payload })
    return Promise.resolve(result)
  },
  cadastrarItem: async (_, payload) => {
    const result = await http.post(`entidades/cliente`, payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(`entidades/cliente`, payload)
    return Promise.resolve(result)
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },
  'LISTA_ITEM' (state, payload) {
    state.item = cloneDeep(payload)
  },
  'LIMPAR_ITEM' (state){
    state.item = {
      name: ''
    }
  },
  'LISTA_ITENS_SELECT' () {
  }
}

const getters = {
  listaItens: state => state.itens,
  item: state => state.item,
  listaItensSelect: (state) => {
    return map(state.itens, item => {
      return {
        text: item.name,
        value: item.id
      }
    })
  },
  totalItens: state => state.totalItens,
}

export default { namespaced: true, state, actions, mutations, getters }